module.exports = __webpack_public_path__ + "static/media/main.d5130643.png";